var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("baseInfo.rateManagement.setRateCacheRange"),
        width: _vm.$selectByLang("450px", "450px", "740px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("90px", "90px", "130px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { staticClass: "margin-Right50" },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("baseInfo.rateManagement.setRateCacheRangePrefix")
                  ) +
                  " "
              ),
              _c("el-input-number", {
                staticStyle: { width: "120px" },
                attrs: {
                  no: "monthRange",
                  "controls-position": "right",
                  max: 36,
                  min: 18,
                  precision: 0
                },
                model: {
                  value: _vm.form.monthRange,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "monthRange", $$v)
                  },
                  expression: "form.monthRange"
                }
              }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("baseInfo.rateManagement.setRateCacheRangeSuffix")
                  ) +
                  " "
              )
            ],
            1
          ),
          _c("el-form-item", { staticClass: "margin-Right50" }, [
            _c("i", { staticClass: "el-icon-warning orange" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("baseInfo.rateManagement.setRateCacheRangeNote")
                ) +
                " "
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirmHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }